import { useMemo, useRef } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import NotFoundPage from "./NotFoundPage";
import {
    publicRoutes as allPublicRoutes,
    protectedRoutes as allProtectedRoutes,
} from "./allRoutes";
import ErrorBoundary from "../ErrorBoundary";
import PrivateRoute from "./PrivateRoute";
import Topbar from "../_components/Topbar/Topbar";

function Routes() {
    const currentLocation = useLocation();

    const { menuRights } = useSelector((state) => ({ menuRights: state.user?.menuRights, }));

    const pageContainerRef = useRef();
    const fileteredProtectedRoutes = useMemo(() => {
        let all = [];
        allProtectedRoutes?.forEach((pRoute) => {
            if (
                [...(menuRights || [])]?.findIndex(
                    (el) => el.path === pRoute.path
                ) !== -1
            ) {
                all.push(pRoute);
                if (pRoute.subRoutes) {
                    all = [...all, ...(pRoute.subRoutes || [])];
                }
            }
        });

        return all;
    }, [menuRights]);

    const publicRoutesMap = useMemo(
        () =>
            allPublicRoutes.map(({ Component, title, path, ...rest }) => {
                return (
                    <Route
                        key={path}
                        exact
                        path={path}
                        render={() =>
                            rest?.header ? (
                                <>
                                    <Topbar />
                                    <Component />
                                </>
                            ) : (
                                <Component />
                            )
                        }
                        title={title}
                    />
                );
            }),
        []
    );

    const privateRoutesMap = useMemo(
        () =>
            fileteredProtectedRoutes.map(({ Component, title, path, ...rest }) => {
                return (
                    <PrivateRoute
                        exact
                        key={path}
                        path={path}
                        component={(props) => {
                            const routeInMenu = menuRights?.find(el => el.path === path || el.link === path);
                            
                            if (routeInMenu && !routeInMenu.ifAccessGranted) {
                                return <Redirect to="/" />;
                            }

                            if (!routeInMenu) {
                                const lowerPath = path.toLowerCase();
                                const isActionRoute = lowerPath.includes('add') || 
                                                      lowerPath.includes('edit') || 
                                                      lowerPath.includes('view') || 
                                                      lowerPath.includes('performainvoice') ||
                                                      path.includes(':');
                                                      
                                if (!isActionRoute) {
                                    return <Redirect to="/" />;
                                }
                            }

                            return rest?.header ? (
                                <>
                                    {/* <MarqueeSlider /> */}
                                    <Topbar />
                                    <Component {...props} />
                                </>
                            ) : (
                                <Component {...props} />
                            );
                        }}
                        title={title}
                    />
                );
            }),
        [fileteredProtectedRoutes, menuRights]
    );

    return (
        <div
            id="page-container"
            ref={pageContainerRef}
        >
            <ErrorBoundary>
                <Switch>
                    {/* -------------------------- */}
                    {publicRoutesMap}

                    {privateRoutesMap}

                    {/* --------------------------- */}
                    <PrivateRoute
                        exact
                        path="/404NotFound"
                        title="Not Found"
                        component={NotFoundPage}
                    />
                    {/* _------------------- */}

                    {localStorage.getItem("token") ? (
                        <PrivateRoute path="*" component={NotFoundPage} />
                    ) : (
                        <Redirect
                            to={{ pathname: "/login", state: { from: currentLocation } }}
                        />
                    )}
                </Switch>
            </ErrorBoundary>
        </div>
    );
}

export default Routes;
